// Global Instructions Rule Applied!
//
// A fund's default carried interest terms - the LPA's figures, which every
// commitment without a side-letter term inherits (funds.base_carry_rate /
// base_hurdle_multiple / stepped_carry_rate / stepped_hurdle_multiple; the
// engine's wf__lp_terms resolves commitment → fund → 0 % / 1x). The one shape
// the Terms tab, the Waterfall section's wording and the commitment forms'
// placeholders share, picked from any record that carries the funds__ keys.

export interface FundCarryDefaults {
  /** a fraction (0.2) */
  base_carry_rate: number | null
  /** × contributed capital (1 = return of capital) */
  base_hurdle_multiple: number | null
  /** a fraction; null = no step (the base rate throughout) */
  stepped_carry_rate: number | null
  /** × contributed capital; null = no step */
  stepped_hurdle_multiple: number | null
}

export interface FundCarryDefaultsSource {
  funds__base_carry_rate?: number | null
  funds__base_hurdle_multiple?: number | null
  funds__stepped_carry_rate?: number | null
  funds__stepped_hurdle_multiple?: number | null
}

/** The fund's defaults from a record carrying the funds__ keys; null when it carries none. */
export function fundCarryDefaultsOf(source: FundCarryDefaultsSource | null | undefined): FundCarryDefaults | null {
  if (!source) return null
  const defaults: FundCarryDefaults = {
    base_carry_rate: source.funds__base_carry_rate ?? null,
    base_hurdle_multiple: source.funds__base_hurdle_multiple ?? null,
    stepped_carry_rate: source.funds__stepped_carry_rate ?? null,
    stepped_hurdle_multiple: source.funds__stepped_hurdle_multiple ?? null
  }
  return Object.values(defaults).every((v) => v == null) ? null : defaults
}

/** The stepped figures fall back to the base ones, as the engine's wf__lp_terms does. */
export function effectiveFundCarryDefaults(defaults: FundCarryDefaults): FundCarryDefaults {
  return {
    ...defaults,
    stepped_carry_rate: defaults.stepped_carry_rate ?? defaults.base_carry_rate,
    stepped_hurdle_multiple: defaults.stepped_hurdle_multiple ?? defaults.base_hurdle_multiple
  }
}
